module.exports = __webpack_public_path__ + "static/media/citi_icon_subscribe_white.b8228324.svg";